import React from 'react'
import Container from '../components/Container'
import { ScrollFadeIn, ScrollFadeInStagger } from '../../../components/ScrollFadeIn'
import { FaUserTie, FaDollarSign, FaCompass } from 'react-icons/fa';
import GetStartedButton from '../components/GetStartedButton'

const abundoFeatures = [
    {
        name: 'Dedicated advisor relationship',
        description: 'Your personal finance expert, always one call away.',
        icon: FaUserTie,
        ariaLabel: 'Dedicated financial advisor feature'
    },
    {
        name: 'No account minimums',
        description: 'Start building wealth today, no matter your portfolio size.',
        icon: FaDollarSign,
        ariaLabel: 'No minimum investment requirement feature'
    },
    {
        name: 'Full scope financial guidance',
        description: 'One simple fee, unlimited financial planning expertise.',
        icon: FaCompass,
        ariaLabel: 'Comprehensive financial planning feature'
    },
];

const ComparisonSection = () => {
    const imageSrc = 'https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1709843080/Abundo%20Wealth%20Assets/public-site/Careers/Abundo_Bubble_Log-03_k6ihxo.webp';
    const imageAlt = "Abundo Wealth logo with colorful bubbles representing financial freedom";

    return (
        <Container bgColor="bg-primary-800">
            <div className="grid grid-cols-1 gap-x-20 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                <div className="lg:pr-8 order-1">
                    <div className="lg:max-w-lg font-lato">
                        <ScrollFadeIn>
                            <h2 className="text-white heading-2">
                                How <span className='text-secondary-500'>Abundo</span> Compares
                            </h2>

                        </ScrollFadeIn>
                        <ScrollFadeInStagger faster={false} className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-200 lg:max-w-none">
                            {abundoFeatures.map((feature) => (
                                <ScrollFadeIn key={feature.name}>
                                    <div className="flex" aria-labelledby={`feature-${feature.name.replace(/\s+/g, '-').toLowerCase()}`}>
                                        <dt className="inline font-semibold text-xl text-white">
                                            <feature.icon className="mt-1 h-7 w-7 text-sky-blue-200" aria-hidden="true" />
                                        </dt>
                                        <dd className="text-xl text-gray-300 ml-3 flex flex-col">
                                            <span
                                                id={`feature-${feature.name.replace(/\s+/g, '-').toLowerCase()}`}
                                                className="font-bold text-white text-2xl mb-1"
                                            >
                                                {feature.name}
                                            </span>
                                            <span className="text-sky-blue-100">{feature.description}</span>
                                        </dd>
                                    </div>
                                </ScrollFadeIn>
                            ))}
                        </ScrollFadeInStagger>
                    </div>
                    <div className='mt-10'></div>
                    <ScrollFadeIn>
                        
                        <GetStartedButton id='how-abundo-compares' />

                    </ScrollFadeIn>
                </div>

                {/* Mobile image - below content */}
                <ScrollFadeIn className="lg:hidden order-2 flex justify-center">
                    <img
                        src={`https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1741206529/Abundo%20Wealth%20Assets/public-site/Careers/Abundo_Bubble_Log-03_k6ihxo_v-2_rrlelv.webp`}
                        alt={imageAlt}
                        className="rounded-xl object-contain h-[220px] sm:h-[250px] w-auto mt-8"
                        width={500}
                        height={250}
                    />
                </ScrollFadeIn>

                {/* Desktop image - right side */}
                <ScrollFadeIn className="hidden lg:flex order-2">
                    <img
                        src={imageSrc}
                        alt={imageAlt}
                        className="rounded-xl object-cover h-full w-full"
                        width={2432}
                        height={1280}
                    />
                </ScrollFadeIn>
            </div>
        </Container>
    )
}

export default ComparisonSection